import { makeServicesTypes } from '@/core/container/makeServicesTypes'
import { enumKeysToArray } from '@/utils/enum'

enum AUTOMATION_SERVICES {
  AutomationFlowRepository,
  AutomationFlowService,
  AutomationFlowBulkManager,
  AutomationFlowFormService,
  AutomationFlowSettingsFormService,
  AutomationFlowBuilderService,
  AutomationFlowStepRepository,
  AutomationFlowStepService,
  AutomationFlowServiceManager,
  AutomationFlowStepConfigService,
  AutomationFlowStepMenuService,
  AutomationFlowColumnServiceFactory,
  AutomationFlowFilterServiceFactory,
  AutomationFlowDetailsResolver,
  AutomationTemplateRepository,
  AutomationTemplatePlaceholderRepository,
  AutomationTemplateService,
  AutomationTemplatePlaceholderService,
  AutomationTemplateGridableService,
  AutomationTemplatesFilterServiceFactory,
  AutomationFlowUndoRedoService,
  AutomationFlowDuplicatingFormService,
  AutomationActionSendFormGroupConfiguration,
  AutomationFlowEditingNameFormService,
  AutomationLogsColumnServiceFactory,
  AutomationLogRepository,
  AutomationLogService,
  AutomationLogPreviewRepository,
  AutomationLogStepRepository,
  AutomationFlowStoredValidationResultRepository,
  AutomationFlowStoredValidationResultService,
  AutomationFlowValidationService,
  AutomationFlowValidationRulesBuilderService,
  AutomationFlowStepStatisticsRepository,
  AutomationFlowStepStatisticsService,
  AutomationLogFilterServiceFactory,
  AutomationDelayFieldBuilder,
  AutomationContentFilterFieldBuilder,
  AutomationCountryFilterFieldBuilder,
  AutomationInboundSmsFieldBuilder,
  AutomationInboundEmailFieldBuilder,
  AutomationInboundLiveChatMessageFieldBuilder,
  AutomationInboundWhatsappMessageFieldBuilder,
  AutomationInboundFacebookMessageFieldBuilder,
  AutomationInboundInstagramMessageFieldBuilder,
  AutomationStepAttachmentFileFieldBuilder,
  AutomationFillFromComposeDraftsService,
  AutomationWuehEventManager,
  AutomationFlowStepValidationHelperService,
  AutomationFlowStepExternalIntegrationValidationHelperService,
  AutomationTriggerHubspotSupportService,
  AutomationTriggerZohoSupportService,
  AutomationTriggerShopifySupportService,
  AutomationTriggerWooCommerceSupportService,
  AutomationFlowDependencyPreloaderService,

  // filters
  AutomationAdditionalFilterServiceFactory,
  AutomationAdditionalFiltersMapperService,
  AutomationTriggerNewInboundEmailReceivedTicketFiltersFactory,
  AutomationTriggerNewInboundEmailReceivedMessageFiltersFactory,
  AutomationTriggerNewInboundSmsReceivedFilterServiceFactory,
  AutomationTriggerContactCreatedFilterServiceFactory,
  AutomationTriggerContactCreatedAdditionalFilterServiceFactory,
  AutomationTriggerContactUpdatedWatchedFieldsFilterServiceFactory,
  AutomationTriggerNewInboundLiveChatMessageFilterServiceFactory,
  AutomationTriggerNewInboundWhatsappMessageFilterServiceFactory,
  AutomationTriggerNewInboundFacebookMessageFilterServiceFactory,
  AutomationTriggerNewInboundInstagramMessageFilterServiceFactory,
  AutomationTriggerShopifyBaseFilterServiceFactory,
  AutomationTriggerWooCommerceBaseFilterServiceFactory,
  AutomationActionWooCommerceCouponProductsFilterServiceFactory,
  AutomationTriggerHubspotPropertiesFilterServiceFactory,
  HubspotWatchPropertiesState,
  AutomationTriggerZohoPropertiesFilterServiceFactory,
  ZohoWatchPropertiesState,

  // step services
  AutomationTriggerTagAddedToContactService,
  AutomationTriggerContactAddedToListService,
  AutomationTriggerContactCreatedService,
  AutomationTriggerContactUpdatedService,
  AutomationContactWatchedFieldCriteriaService,
  AutomationTriggerSubscribeFormFilledService,
  AutomationTriggerManuallySelectContactsService,
  AutomationTriggerNewInboundEmailReceivedService,
  AutomationTriggerNewInboundSmsReceivedService,
  AutomationTriggerNewInboundLiveChatMessageService,
  AutomationTriggerNewInboundWhatsappMessageService,
  AutomationTriggerNewInboundFacebookMessageService,
  AutomationTriggerNewInboundInstagramMessageService,
  AutomationActionAddTagService,
  AutomationActionRemoveTagService,
  AutomationActionAddToListService,
  AutomationActionRemoveFromListService,
  AutomationActionCreateNewTaskService,
  AutomationActionCreateNewDealService,
  AutomationActionUnsubscribeContactService,
  AutomationActionUpdateContactService,
  AutomationActionSendEmailService,
  AutomationActionSendEmailReplyService,
  AutomationActionSendSmsService,
  AutomationActionSendWhatsappReplyService,
  AutomationActionSendFacebookReplyService,
  AutomationActionSendInstagramReplyService,
  AutomationActionStopAnotherFlowService,
  AutomationRulePercentageSplitService,
  AutomationRulePercentageSplitBranchService,
  AutomationRuleWaitUntilEventHappensService,
  AutomationRuleConditionalSplitService,
  AutomationRuleDelayService,
  AutomationAdvancedTimeDelayService,
  AutomationRuleReplyBasedSplitService,
  AutomationRuleReplyBasedSplitBranchService,
  AutomationTriggerShopifyOrderCreatedService,
  AutomationTriggerShopifyOrderPaidService,
  AutomationTriggerShopifyOrderFulfilledService,
  AutomationTriggerShopifyOrderShippedService,
  AutomationTriggerShopifyOrderReadyForPickupService,
  AutomationTriggerShopifyAbandonedCheckoutService,
  AutomationTriggerWooCommerceAbandonedCheckoutService,
  AutomationTriggerWooCommerceOrderCreatedService,
  AutomationTriggerWooCommerceOrderPaidService,
  AutomationTriggerWooCommerceOrderCompletedService,
  AutomationTriggerWooCommerceOrderCancelledService,
  AutomationTriggerWooCommerceOrderRefundedService,
  AutomationTriggerWooCommerceOrderFailedService,
  AutomationActionShopifyAddCustomerTagService,
  AutomationActionShopifyAddCustomerNoteService,
  AutomationActionShopifyAddOrderTagService,
  AutomationActionShopifyAddOrderNoteService,
  AutomationActionWooCommerceAddOrderTagService,
  AutomationActionWooCommerceUpdateOrderStatusService,
  AutomationActionWooCommerceCreateCouponService,
  AutomationActionWooCommerceAddOrderNoteService,
  AutomationActionWooCommerceUpdateOrderCustomFieldService,
  AutomationActionWooCommerceUpdateCustomerCustomFieldService,
  AutomationTriggerHubspotContactPropertyUpdatedService,
  AutomationTriggerHubspotContactCreatedService,
  AutomationTriggerZohoContactPropertyUpdatedService,
  AutomationTriggerZohoContactCreatedService,
  AutomationTriggerZohoDealCreatedService,
  AutomationTriggerZohoMeetingCreatedService,
  AutomationTriggerHubspotDealCreatedService,
  AutomationTriggerHubspotDealPropertyUpdatedService,
  AutomationTriggerHubspotTicketCreatedService,
  AutomationTriggerHubspotTicketPropertyUpdatedService,
  AutomationTriggerHubspotTaskCreatedService,
  AutomationTriggerHubspotTaskPropertyUpdatedService,
  AutomationTriggerHubspotOrderCreatedService,
  AutomationTriggerHubspotOrderPropertyUpdatedService,
  AutomationTriggerHubspotMeetingCreatedService,
  AutomationTriggerHubspotMeetingPropertyUpdatedService,
  AutomationTriggerHubspotConversationCreatedService,
  AutomationTriggerHubspotConversationPropertyUpdatedService,
  AutomationTriggerHubspotConversationMessageService,
  AutomationActionHubspotUpdateContactService,
  AutomationActionHubspotAddNoteToContactService,
  AutomationActionHubspotAddNoteToDealService,
  AutomationActionHubspotCreateTaskService,
  AutomationActionHubspotCreateTicketService,
  AutomationActionHubspotCreateDealService,
  AutomationActionHubspotMoveDealToStageService,
  AutomationActionHubspotAddNoteToOrderService,
  AutomationActionHubspotUpdateOrderPropertyService,
  AutomationActionHubspotMoveOrderToStageService,
  AutomationActionHubspotUpdateTaskStatusService,
  AutomationActionHubspotAddContactToListService,
  AutomationActionHubspotRemoveContactFromListService,
  AutomationRuleGoToAnotherStepService,
  AutomationActionSendWebhookService,

  // step form services
  AutomationTriggerTagAddedToContactFormService,
  AutomationTriggerContactAddedToListFormService,
  AutomationTriggerContactCreatedFormService,
  AutomationTriggerContactUpdatedFormService,
  AutomationTriggerSubscribeFormFilledFormService,
  AutomationTriggerManuallySelectContactsFormService,
  AutomationTriggerNewInboundEmailReceivedFormService,
  AutomationTriggerNewInboundSmsReceivedFormService,
  AutomationTriggerNewInboundLiveChatMessageFormService,
  AutomationTriggerNewInboundWhatsappMessageFormService,
  AutomationTriggerNewInboundFacebookMessageFormService,
  AutomationTriggerNewInboundInstagramMessageFormService,
  AutomationActionAddTagFormService,
  AutomationActionRemoveTagFormService,
  AutomationActionAddToListFormService,
  AutomationActionRemoveFromListFormService,
  AutomationActionCreateNewTaskFormService,
  AutomationActionCreateNewDealFormService,
  AutomationActionUnsubscribeContactFormService,
  AutomationActionUpdateContactFormService,
  AutomationActionSendEmailFormService,
  AutomationActionSendEmailReplyFormService,
  AutomationActionSendSmsFormService,
  AutomationActionSendWhatsappReplyFormService,
  AutomationActionSendFacebookReplyFormService,
  AutomationActionSendInstagramReplyFormService,
  AutomationActionStopAnotherFlowFormService,
  AutomationRulePercentageSplitFormService,
  AutomationRuleWaitUntilEventHappensFormService,
  AutomationRuleConditionalSplitFormService,
  AutomationAdvancedTimeDelayFormService,
  AutomationRuleReplyBasedSplitFormService,
  AutomationTriggerShopifyOrderCreatedFormService,
  AutomationTriggerShopifyOrderPaidFormService,
  AutomationTriggerShopifyOrderFulfilledFormService,
  AutomationTriggerShopifyOrderShippedFormService,
  AutomationTriggerShopifyOrderReadyForPickupFormService,
  AutomationTriggerShopifyAbandonedCheckoutFormService,
  AutomationTriggerWooCommerceAbandonedCheckoutFormService,
  AutomationTriggerWooCommerceOrderCreatedFormService,
  AutomationTriggerWooCommerceOrderPaidFormService,
  AutomationTriggerWooCommerceOrderCompletedFormService,
  AutomationTriggerWooCommerceOrderCancelledFormService,
  AutomationTriggerWooCommerceOrderRefundedFormService,
  AutomationTriggerWooCommerceOrderFailedFormService,
  AutomationActionShopifyAddCustomerTagFormService,
  AutomationActionShopifyAddCustomerNoteFormService,
  AutomationActionShopifyAddOrderTagFormService,
  AutomationActionShopifyAddOrderNoteFormService,
  AutomationActionWooCommerceAddOrderTagFormService,
  AutomationActionWooCommerceUpdateOrderStatusFormService,
  AutomationActionWooCommerceCreateCouponFormService,
  AutomationActionWooCommerceAddOrderNoteFormService,
  AutomationActionWooCommerceUpdateOrderCustomFieldFormService,
  AutomationActionWooCommerceUpdateCustomerCustomFieldFormService,
  AutomationTriggerHubspotContactPropertyUpdatedFormService,
  AutomationTriggerHubspotContactCreatedFormService,
  AutomationTriggerZohoContactPropertyUpdatedFormService,
  AutomationTriggerZohoContactCreatedFormService,
  AutomationTriggerZohoDealCreatedFormService,
  AutomationTriggerZohoMeetingCreatedFormService,
  AutomationTriggerHubspotDealCreatedFormService,
  AutomationTriggerHubspotDealPropertyUpdatedFormService,
  AutomationTriggerHubspotTicketCreatedFormService,
  AutomationTriggerHubspotTicketPropertyUpdatedFormService,
  AutomationTriggerHubspotTaskCreatedFormService,
  AutomationTriggerHubspotTaskPropertyUpdatedFormService,
  AutomationTriggerHubspotOrderCreatedFormService,
  AutomationTriggerHubspotOrderPropertyUpdatedFormService,
  AutomationTriggerHubspotMeetingCreatedFormService,
  AutomationTriggerHubspotMeetingPropertyUpdatedFormService,
  AutomationTriggerHubspotConversationCreatedFormService,
  AutomationTriggerHubspotConversationPropertyUpdatedFormService,
  AutomationTriggerHubspotConversationMessageFormService,
  AutomationActionHubspotUpdateContactFormService,
  AutomationActionHubspotAddNoteToContactFormService,
  AutomationActionHubspotAddNoteToDealFormService,
  AutomationActionHubspotCreateTaskFormService,
  AutomationActionHubspotCreateTicketFormService,
  AutomationActionHubspotCreateDealFormService,
  AutomationActionHubspotMoveDealToStageFormService,
  AutomationActionHubspotAddNoteToOrderFormService,
  AutomationActionHubspotUpdateOrderPropertyFormService,
  AutomationActionHubspotMoveOrderToStageFormService,
  AutomationActionHubspotUpdateTaskStatusFormService,
  AutomationActionHubspotAddContactToListFormService,
  AutomationActionHubspotRemoveContactFromListFormService,
  AutomationRuleGoToAnotherStepFormService,
  AutomationActionSendWebhookFormService,

  // wait until event happens builders
  AutomationWuehContactListSharedBuilder,
  AutomationWuehContactIsAddedToListBuilder,
  AutomationWuehContactRemovedFromListBuilder,
  AutomationWuehEmailSharedBuilder,
  AutomationWuehEmailOpenedBuilder,
  AutomationWuehLinkInEmailClickedBuilder,
  AutomationWuehContactTagSharedBuilder,
  AutomationWuehTagIsAddedToContactBuilder,
  AutomationWuehTagRemovedFromContactBuilder,
  AutomationWuehUnsubscribedFromEmailsBuilder,
  AutomationWuehInboundMessageComplexBuilder,
  AutomationWuehShopifyOrderCreatedBuilder,
  AutomationWuehShopifyOrderPaidBuilder,
  AutomationWuehShopifyOrderFulfilledBuilder,
  AutomationWuehShopifyOrderShippedBuilder,
  AutomationWuehShopifyOrderReadyForPickupBuilder,
  AutomationWuehShopifyAbandonedCheckoutBuilder,
  AutomationWuehWooCommerceOrderCreatedBuilder,
  AutomationWuehWooCommerceOrderPaidBuilder,
  AutomationWuehWooCommerceOrderCompletedBuilder,
  AutomationWuehWooCommerceOrderCancelledBuilder,
  AutomationWuehWooCommerceOrderRefundedBuilder,
  AutomationWuehWooCommerceOrderFailedBuilder,
  AutomationWuehWooCommerceAbandonedCheckoutBuilder,
  AutomationWuehHubspotContactCreatedBuilder,
  AutomationWuehHubspotContactPropertyChangedBuilder,
  AutomationWuehHubspotDealCreatedBuilder,
  AutomationWuehHubspotDealPropertyChangedBuilder,
  AutomationWuehHubspotTicketCreatedBuilder,
  AutomationWuehHubspotTicketPropertyChangedBuilder,
  AutomationWuehHubspotTaskCreatedBuilder,
  AutomationWuehHubspotTaskPropertyChangedBuilder,
  AutomationWuehHubspotOrderCreatedBuilder,
  AutomationWuehHubspotOrderPropertyChangedBuilder,
  AutomationWuehHubspotMeetingCreatedBuilder,
  AutomationWuehHubspotMeetingPropertyChangedBuilder,
  AutomationWuehHubspotConversationCreatedBuilder,
  AutomationWuehHubspotConversationPropertyChangedBuilder,
  AutomationWuehHubspotConversationMessageBuilder,

  // wait until event happens builders for inbound message complex event channels
  AutomationWuehInboundSmsBuilder,
  AutomationWuehInboundEmailBuilder,
  AutomationWuehInboundLiveChatMessageBuilder,
  AutomationWuehInboundWhatsappMessageBuilder,
  AutomationWuehInboundFacebookMessageBuilder,
  AutomationWuehInboundInstagramMessageBuilder,

  // wait until event happens event services
  AutomationWuehDefaultEventService,
  AutomationWuehContactListEventService,
  AutomationWuehTagEventService,
  AutomationWuehHubspotPropertyChangedEventService,
  AutomationWuehEmailEventService,
  AutomationWuehLinkInEmailClickedEventService,
  AutomationWuehInboundEmailEventService,
  AutomationWuehInboundSmsEventService,
  AutomationWuehInboundLiveChatMessageEventService,
  AutomationWuehInboundWhatsappMessageEventService,
  AutomationWuehInboundFacebookMessageEventService,
  AutomationWuehInboundInstagramMessageEventService,
  AutomationWuehInboundMessageComplexEventService,

  // step node builders
  AutomationBaseNodeBuilderService,
  AutomationNoopNodeBuilderService,
  AutomationContactExitsNodeBuilderService,
  AutomationSplitNodeBuilderService,
  AutomationRuleWaitUntilEventHappensNodeBuilderService,
  AutomationRuleReplyBasedNodeBuilderService,
  AutomationRuleGoToAnotherStepNodeBuilderService,

  // tables
  AutomationStepContactColumnServiceFactory,
  AutomationStepContactFilterServiceFactory,
  AutomationStepContactSorterServiceFactory,

  // resolvers
  AutomationStepResolverManager,
  AutomationTriggerNewInboundEmailReceivedResolver,
  AutomationActionSendEmailReplyResolver,
  AutomationActionCreateNewDealResolver,
  AutomationStepWebWidgetResolver,
  AutomationStepSubscribeFormResolver,
  AutomationStepWhatsAppResolver,
  AutomationStepFacebookPageResolver,
  AutomationStepInstagramAccountResolver,
  AutomationStepExternalIntegrationResolver,
  AutomationActionSendWhatsappReplyResolver,
  AutomationActionSendFacebookReplyResolver,
  AutomationActionSendInstagramReplyResolver,

  // payload converters
  AutomationStepPayloadConverterManager,
  AutomationActionEmailToEmailReplyPayloadConverter,
  AutomationActionEmailReplyToEmailPayloadConverter,
  AutomationChannelReplyPayloadConverter,

  // ai builder
  AutomationFlowAiBuilderService,
  AutomationFlowAiBuilderRepository,
  AutomationFlowAiBuilderResolver,
  AutomationFlowAiConversationRepository,
  AutomationFlowAiConversationService,
  AutomationFlowAiConversationMessageRepository,
  AutomationFlowAiConversationMessageService,
  AutomationFlowAiAvailabilityRepository,
  AutomationFlowAiAvailabilityService,
  AutomationFlowAiPromptSuggestionRepository,
  AutomationFlowAiPromptSuggestionService,
}

export type AutomationServices = keyof typeof AUTOMATION_SERVICES

export const AUTOMATION_SERVICE_TYPES: Record<AutomationServices, symbol> = makeServicesTypes<AutomationServices>(
  enumKeysToArray<AutomationServices>(AUTOMATION_SERVICES),
)
